import React, { useEffect, useState } from 'react'

import { Upload, message } from "antd";
import axios from "axios";
import { InboxOutlined } from "@ant-design/icons";
import moment from "moment";
const { Dragger } = Upload;

export default function UploadPdf({ id, prefix, type, setLoading }) {

    const [lastUpdated, setLastUpdated] = useState("");

    useEffect(() => {
        // Run! Like go get some data from an API.
        const fetchLastUpdate = () => {
            // Make a request for a user with a given ID
            axios
                .get(`${process.env.REACT_APP_SERVER_URL}/api/files/Get${prefix}Meta?id=${id}`)
                .then((response) => {
                    console.log(response)
                    // handle success
                    setLastUpdated(response.data)
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
                .then(() => {
                    // always executed
                });
        }

        fetchLastUpdate()

    }, []);

    function upload(file) {
        var formData = new FormData();
        formData.append("file", file);


        setLoading(true)

        axios
            .post(`${process.env.REACT_APP_SERVER_URL}/api/files/${prefix}?id=${id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "",
                },
            })
            .then((response) => {
                console.log(response);
                // this.fetchLastUpdate();
                setLoading(false)
            }).catch((error) => {
                message.error("Il limite del file e' di 15Mb")
                setLoading(false)
            });
    }


    function uploadThumbnail(file) {
        var formData = new FormData();
        formData.append("file", file);

        setLoading(true)

        axios
            .post(`${process.env.REACT_APP_SERVER_URL}/api/files/Thumbnail?type=${prefix.toLowerCase()}&id=${id}`, formData, {
                headers: {
                    "Content-Type": "image/png",
                    Authorization: "",
                },
            })
            .then((response) => {
                console.log(response);
                // this.fetchLastUpdate();
                setLoading(false)
                window.location.reload()
            }).catch((error) => {
                message.error("Il limite del file e' di 15Mb")
                setLoading(false)
            });
    }


    const attributes = {
        name: "file",
        action: type === "pdf" ? upload : uploadThumbnail,
        showUploadList: false,
        accept: type === "pdf" ? ".pdf" : "image/png"
    };

    const dateFormat = "DD/MM/YYYY HH:mm";


    if (type === "pdf") {
        return (
            <div id="upload_button">
                <Dragger {...attributes}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                        Fare clic o trascinare il file in quest'area per caricarlo
        </p>
                    <p className="ant-upload-hint">Deve essere in formato Pdf</p>

                    <p>
                        {" "}
          Ultimo aggiornamento:{" "}
                        {moment(lastUpdated).format(dateFormat).toString()}{" "}
                    </p>
                </Dragger>
            </div>
        );
    } else {
        return (
            <div id="upload_button">
                <Dragger {...attributes}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                        Fare clic o trascinare il file in quest'area per caricare il thumbnail
        </p>
                    <p className="ant-upload-hint">Deve essere in formato PNG</p>

                    <p>
                        {" "}
          Ultimo aggiornamento:{" "}
                        {moment(lastUpdated).format(dateFormat).toString()}{" "}
                    </p>
                </Dragger>
            </div>
        );

    }



}
